module.exports = __webpack_public_path__ + "img/3.89bee69b.jpg";